// Journalism Multi-Agent Models

export interface MultiJournalismRequest {
  topic: string;
  style?: string;
  toneGuidance?: string;
  keyFacts?: string[];
  perspective?: string;
  maxTokensPerAgentTurn?: number;
  iterations?: number;
}

export interface MultiJournalismResponse {
  finalArticle?: string;
}

export interface JournalismSession {
  id: string;
  topic: string;
  style?: string;
  toneGuidance?: string;
  keyFacts?: string[];
  perspective?: string;
  finalArticle?: string;
  researchNotes?: string;
  createdAt: Date;
  iterations?: number;
}

export interface JournalismSessionStorage {
  sessions: JournalismSession[];
  lastUpdated: Date;
}

// Common options for UI
export const JOURNALISM_STYLES = [
  'News Article',
  'Feature Story',
  'Investigative Report',
  'Opinion/Editorial',
  'Interview',
  'Profile Piece',
  'Breaking News',
  'Analysis',
  'Long-form Journalism',
  'Magazine Article',
  'Blog Post',
  'Press Release'
];

export const TONE_OPTIONS = [
  'Objective/Neutral',
  'Authoritative',
  'Conversational',
  'Analytical',
  'Investigative',
  'Critical',
  'Sympathetic',
  'Urgent',
  'Explanatory',
  'Persuasive',
  'Humorous',
  'Serious'
];

export const PERSPECTIVE_OPTIONS = [
  'Third-person objective',
  'First-person narrative',
  'Expert analysis',
  'Multiple viewpoints',
  'Historical context',
  'Future-focused',
  'Solution-oriented',
  'Problem-focused',
  'Human interest',
  'Data-driven'
];